import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Surface meaningful errors so users know what to do.
api.interceptors.response.use(
  (resp) => resp,
  (error) => {
    // Network/CORS/timeout — no response object at all
    if (!error.response) {
      error.message =
        "Cannot reach the server. Please check your connection or try again in a moment.";
    }
    return Promise.reject(error);
  }
);

export function formatApiError(detail) {
  if (detail == null) return ""; // let caller fall back to error.message
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function formatMoney(amount, currency = "usd") {
  const n = Number(amount || 0);
  try {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: (currency || "usd").toUpperCase(),
      minimumFractionDigits: 2,
    }).format(n);
  } catch {
    return `$${n.toFixed(2)}`;
  }
}
